import { render, staticRenderFns } from "./RecruitDetail.vue?vue&type=template&id=051a8ed0&"
import script from "./RecruitDetail.vue?vue&type=script&lang=js&"
export * from "./RecruitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports